module.exports = __webpack_public_path__ + "img/1A.e70d7991.jpg";